import { render, staticRenderFns } from "./RestartOnConfigurationUpdate.vue?vue&type=template&id=6e74e294"
import script from "./RestartOnConfigurationUpdate.vue?vue&type=script&lang=js"
export * from "./RestartOnConfigurationUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports